// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32hM0","option":"styles_option__3yHqp","active":"styles_active__qDz5C"};